<template>
  <section class="import-section">
    <div class="import-container">
      <h2 class="import-title">数据导入与生成功能</h2>
      <div class="import-content">
        <div 
          class="upload-zone" 
          :class="{ 'dragover': isDragOver }"
          @click="$refs.fileInput.click()"
          @dragover.prevent="handleDragOver"
          @dragleave.prevent="handleDragLeave"
          @drop.prevent="handleDrop"
        >
          <input 
            ref="fileInput"
            type="file" 
            style="display: none;" 
            multiple 
            accept=".pdf,.doc,.docx,.txt,.xlsx,.ppt,.pptx"
            @change="handleFileSelect"
          >
          <div class="upload-icon">📄</div>
          <div class="upload-text">点击或拖拽文件导入</div>
          <div class="upload-hint">支持PDF、DOC、TXT、XLSX等多种格式</div>
        </div>
        
        <div class="import-features">
          <div 
            v-for="feature in importFeatures" 
            :key="feature.title"
            class="import-feature"
            @click="handleImportFeatureClick(feature)"
          >
            <div class="import-feature-icon">{{ feature.icon }}</div>
            <div class="import-feature-text">
              <div class="import-feature-title">{{ feature.title }}</div>
              <div class="import-feature-desc">{{ feature.desc }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'DataImport',
  data() {
    return {
      isDragOver: false,
      importFeatures: [
        {
          icon: '📁',
          title: '文件上传导入',
          desc: '支持批量上传建筑工程技术文档、标准规范等'
        },
        {
          icon: '🔄',
          title: '实时数据写入',
          desc: '支持API接口实时更新知识库和图谱数据'
        },
        {
          icon: '🧠',
          title: '智能内容解析',
          desc: 'AI自动提取知识点并生成图谱关联关系'
        },
        {
          icon: '🔗',
          title: '跨层数据耦合',
          desc: '支持公有库、专业库、私有库间的数据关联'
        }
      ]
    }
  },
  methods: {
    handleDragOver(e) {
      this.isDragOver = true
    },
    
    handleDragLeave(e) {
      this.isDragOver = false
    },
    
    handleDrop(e) {
      this.isDragOver = false
      const files = Array.from(e.dataTransfer.files)
      this.processFiles(files)
    },
    
    handleFileSelect(e) {
      const files = Array.from(e.target.files)
      this.processFiles(files)
    },
    
    processFiles(files) {
      console.log('处理文件:', files.map(f => f.name))
      
      // 模拟上传进度
      alert(`文档导入完成！\n\n已处理 ${files.length} 个文件\n提取知识点：${Math.floor(Math.random() * 100 + 50)} 个\n生成关联关系：${Math.floor(Math.random() * 50 + 20)} 条\n\n文档已自动分类到相应知识库中。`)
    },
    
    handleImportFeatureClick(feature) {
      alert(`${feature.title}\n\n${feature.desc}\n\n点击可进入详细配置界面。`)
    }
  }
}
</script>

<style scoped>
/* 数据导入部分 */
.import-section {
  background: white;
  padding: 80px 0;
  border-top: 1px solid #E5E7EB;
  border-bottom: 1px solid #E5E7EB;
}

.import-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.import-title {
  text-align: center;
  font-size: 40px;
  font-weight: 800;
  margin-bottom: 60px;
  background: linear-gradient(135deg, #4682B4 0%, #2E5CE6 50%, #FF6B35 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.import-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 48px;
  align-items: center;
}

.upload-zone {
  border: 3px dashed #D1D5DB;
  border-radius: 24px;
  padding: 60px 40px;
  text-align: center;
  background: #F9FAFB;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.upload-zone:hover {
  border-color: #2E5CE6;
  background: rgba(46, 92, 230, 0.05);
  transform: translateY(-4px);
}

.upload-zone.dragover {
  border-color: #2E5CE6;
  background: rgba(46, 92, 230, 0.1);
  transform: scale(1.02);
}

.upload-zone::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(46, 92, 230, 0.05) 0%, transparent 70%);
  animation: float-element 20s infinite linear;
}

.upload-icon {
  font-size: 64px;
  opacity: 0.4;
  margin-bottom: 24px;
  position: relative;
  z-index: 1;
}

.upload-text {
  color: #111827;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 12px;
  position: relative;
  z-index: 1;
}

.upload-hint {
  color: #6B7280;
  font-size: 14px;
  position: relative;
  z-index: 1;
}

.import-features {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.import-feature {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px;
  background: #F9FAFB;
  border-radius: 16px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
}

.import-feature:hover {
  background: white;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  transform: translateX(8px);
}

.import-feature-icon {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #2E5CE6 0%, #FF6B35 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 20px;
  flex-shrink: 0;
}

.import-feature-text {
  flex: 1;
}

.import-feature-title {
  font-size: 16px;
  font-weight: 600;
  color: #111827;
  margin-bottom: 4px;
}

.import-feature-desc {
  font-size: 14px;
  color: #6B7280;
}

@keyframes float-element {
  0% {
    transform: translateY(100vh) rotate(0deg);
  }
  100% {
    transform: translateY(-100px) rotate(360deg);
  }
}

/* 响应式设计 */
@media (max-width: 1024px) {
  .import-content {
    grid-template-columns: 1fr;
    gap: 32px;
  }
}
</style>